// extracted by mini-css-extract-plugin
export default {"wrapper":"Shop_wrapper__0a8zU","shop":"Shop_shop__s3+fr","name":"Shop_name__-RahF","images":"Shop_images__VDs1g","sort":"Shop_sort__9Lrn8","arrow":"Shop_arrow__ao7mo"};